// Importa as funções necessárias do SDK do Firebase
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Configurações gerais da API
const config = {
    apiBaseUrl: 'https://gardai.azurewebsites.net', // URL base da API

    // Configurações do Firebase
    firebaseConfig: {
        apiKey: "AIzaSyAqpoSCc1mDHBW8IijH1D5-5OrBg1j3wOo",
        authDomain: "guardai-web.firebaseapp.com",
        projectId: "guardai-web",
        storageBucket: "guardai-web.appspot.com",
        messagingSenderId: "375946215561",
        appId: "1:375946215561:web:99ee518e0f929b2804c658",
        measurementId: "G-DP86319S03"
    }
};

// Inicializa o Firebase
const firebaseApp = initializeApp(config.firebaseConfig);

// Inicializa a autenticação do Firebase
const auth = getAuth(firebaseApp);

// Inicializa o Analytics (opcional, apenas se necessário)
const analytics = getAnalytics(firebaseApp);

// Exporta as configurações e o Firebase Auth
export { config, auth, analytics };
